import React from 'react';
import { QueryProvider } from './QueryProvider';

export const SearchSerialNumbersProviders = ({ children }: any) => {
	return <QueryProvider>{children}</QueryProvider>;
};
